// import Config from "@/model/Config";
import axios from "axios";
import { baseUrl } from "./const";
import TipoChamado from '@/model/TipoChamado';
import Chamado from '@/model/Chamado';
import Leito from '@/model/Leito';
import Quarto from '@/model/Quarto';
import Setor from '@/model/Setor';

const Api = {
    _baseUrl: baseUrl,

    carregaConfig: function () {
        const request = axios.get(`${this._baseUrl}/Config/listar`)
            .then(resposta => { return resposta.data })
            .catch(erro => console.log(erro));

        return request;
    },
    tipoChamadoListar: function (tiposChamados) {
        // console.log(`${this._baseUrl}/TipoChamado/listarPai`);
        const request = axios.get(`${this._baseUrl}/TipoChamado/listarPai`)
            // .then(resposta => {
            //     resposta.data.forEach(tpCh => {
            //         tiposChamados.push(new TipoChamado(tpCh.id, tpCh.descricao,
            //             tpCh.ativo, tpCh.cor, tpCh.som, tpCh.fonte, tpCh.borda, tpCh.corIcone, tpCh.urgencia, tpCh.id_Principal));
            //     });
            // })
            .then(resposta => { return resposta.data })
            .catch(erro => console.log(erro));
        return request;
    },
    listarAbertos: function (idLeito, chamadosAbertos) {
        const request = axios.get(`${this._baseUrl}/Chamado/listarAbLeito?IdLeito=${idLeito}`)
            .then(resposta => {
                resposta.data.forEach(listAb => {
                    chamadosAbertos.push(
                        new Chamado(
                            listAb.id,
                            listAb.data,
                            listAb.hora,
                            new Leito(listAb.leito.id, listAb.leito.codigoLeito, listAb.leito.descricao, listAb.leito.ativo,
                                new Quarto(listAb.leito.quarto.id, listAb.leito.quarto.codigoQuarto, listAb.leito.quarto.descricao, listAb.leito.quarto.ativo,
                                    new Setor(listAb.leito.quarto.setor.id, listAb.leito.quarto.setor.ativo, listAb.leito.quarto.setor.codigoSetor, listAb.leito.quarto.setor.descricao)
                                )
                            ),
                            new TipoChamado(listAb.tipoChamado.id, listAb.tipoChamado.descricao, listAb.tipoChamado.ativo, listAb.tipoChamado.cor, listAb.tipoChamado.som, listAb.tipoChamado.fonte, listAb.tipoChamado.borda, listAb.tipoChamado.corIcone, listAb.urgencia, listAb.id_Principal),
                            listAb.posicao,
                            listAb.dtFinalizacao,
                            listAb.hrFinalizacao,
                            listAb.dtCancelamento,
                            listAb.hrCancelamento,
                            listAb.motivo,
                            listAb.letraEquipamento,
                            listAb.letraChamado,
                            listAb.avaliacao
                        )
                    );
                })
                return chamadosAbertos;
            })
            .catch(erro => console.log(erro));
        return request;
    },
    finalizarAtendimento: function (id) {
        const request = axios.post(`${this._baseUrl}/Chamado/Finalizar?pIdChamado=${id}`)
            .then(resposta => { return resposta.data })
            .catch(erro => console.log(erro));

        return request;
    },
    cancelarAtendimento: function (id) {
        const request = axios.post(`${this._baseUrl}/Chamado/Cancelar?pIdChamado=${id}`)
            .then(resposta => { return resposta.data })
            .catch(erro => console.log(erro));

        return request;
    },
    listarLeitoId: function (pIdLeito, ativos) {
        let where = "";
        if (ativos == true)
            where = "&exibirAtivos=true"
        else if (ativos == false)
            where = "&exibirAtivos=false"
        const request = axios.get(`${this._baseUrl}/Leito/listarPorId?pIdLeito=${pIdLeito}${where}`)
            .then(resposta => { return resposta.data })
            .catch(erro => console.log(erro));

        return request;
    },
    filtrarDados: function (pPosicao, pIdTipoChamado, pIdSetor, pIdQuarto, pIdLeito) {
        if (pIdTipoChamado == null) {
            pIdTipoChamado = 0;
        }
        if (pIdSetor == null) {
            pIdSetor = 0;
        }
        if (pIdQuarto == null) {
            pIdQuarto = 0;
        }
        if (pIdLeito == null) {
            pIdLeito = 0;
        }
        // console.log(`Posicao ${pPosicao} idChamado: ${pIdTipoChamado} Setor: ${pIdSetor} Quarto: ${pIdQuarto} Leito: ${pIdLeito}`)
        const request = axios.get(`${this._baseUrl}/Chamado/listarDinamico?pPosicao=${pPosicao}
            &pIdTipoChamado=${pIdTipoChamado}&pIdSetor=${pIdSetor}&pIdQuarto=${pIdQuarto}&pIdLeito=${pIdLeito}`)
            .then(resposta => { return resposta.data })
            .catch(erro => console.log(erro));

        return request;
    },
    realizarChamado: function (pIdChamado, pIdLeito) {
        console.log(`${this._baseUrl}/Chamado/Chamar?pIdTipoChamado=${pIdChamado}&pIdLeito=${pIdLeito}`);
        const request = axios.post(`${this._baseUrl}/Chamado/Chamar?pIdTipoChamado=${pIdChamado}&pIdLeito=${pIdLeito}`)
            .then(resposta => { return resposta.data })
            .catch(erro => {
                alert(`Parece que há um problema de conexão ${erro}`)
            });

        return request;
    },

    tipoChamadoListarSub: function (pIdPrincipal) {
        const request = axios.get(`${this._baseUrl}/TipoChamado/listarSub?IdPrincipal=${pIdPrincipal}`)
            .then(resposta => { return resposta.data })
            .catch(erro => console.log(erro));

        return request;
    },

    tipoChamadoExisteSub: function (pIdPrincipal) {
        const request = axios.get(`${this._baseUrl}/TipoChamado/ExisteSub?IdPrincipal=${pIdPrincipal}`)
            .then(resposta => { return resposta.data })
            .catch(erro => console.log(erro));

        return request;
    },
    // ChamadoAlterar: function (pObj) {
    //     const request = axios.post(`${this._baseUrl}/Chamado/Alterar`,pObj)
    //         .then(resposta => { return resposta.data })
    //         .catch(erro => console.log(erro));

    //     return request;
    // },
    ChamadoAvaliar: function (pId, pValor, pAvaliacaoTexto) {
        const request = axios.post(`${this._baseUrl}/Chamado/Avaliar?pIdChamado=${pId}&pAvaliacao=${pValor}&pOpiniao=${pAvaliacaoTexto}`)
            .then(resposta => { return resposta.data })
            .catch(erro => console.log(erro));

        return request;
    },

};
export default Api;